import { TextField, IconButton, InputAdornment } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

interface ReadOnlyFormFieldProps {
  label?: string;
  value?: string | null;
  helperText?: string;
  fullWidth?: boolean;
  editData?: any;
  fieldPath?: string;
  onEdit?: (editData?: any) => void;
  [key: string]: unknown;
}

export function ReadOnlyFormField({
  label,
  value,
  helperText,
  fullWidth = true,
  editData,
  fieldPath,
  onEdit,
  ...rest
}: ReadOnlyFormFieldProps) {
  // Если передан fieldPath, извлекаем значение из editData
  let displayValue = value;
  if (fieldPath && editData) {
    const pathParts = fieldPath.split(".");
    displayValue = pathParts.reduce((obj, path) => obj?.[path], editData);
  }

  displayValue = displayValue || "—";

  return (
    <TextField
      {...rest}
      label={label}
      value={displayValue}
      disabled
      fullWidth={fullWidth}
      variant="outlined"
      helperText={helperText}
      InputProps={{
        readOnly: true,
        endAdornment: onEdit && (
          <InputAdornment position="end">
            <IconButton
              onClick={() => onEdit?.(editData)}
              size="small"
              sx={{ color: "action.active" }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: "rgba(0, 0, 0, 0.38)", // Более серый цвет как у disabled полей
        },
        "& .MuiInputLabel-root.Mui-disabled": {
          color: "rgba(0, 0, 0, 0.38)", // Серый цвет для лейбла
        },
        "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "rgba(0, 0, 0, 0.23)", // Серый бордер
          },
      }}
    />
  );
}
